import "core-js/modules/es.array.map.js";
import React from 'react';
import { isArray } from '@finect/front-utils/isArray';
import { Tooltip } from '../Tooltip';
import { formatter } from './utils';
export var DateLabel = function DateLabel(_ref) {
  var date = _ref.date,
    format = _ref.format,
    _ref$tooltip = _ref.tooltip,
    tooltip = _ref$tooltip === void 0 ? null : _ref$tooltip;
  try {
    var test = date.toISOString();
  } catch (error) {
    return null;
  }
  var component = React.createElement("time", {
    dateTime: date.toISOString()
  }, isArray(format) ? format.map(function (item) {
    return formatter(date, item);
  }).join(' ') : formatter(date, format));
  var _ref2 = tooltip || {},
    _ref2$format = _ref2.format,
    tooltipFormat = _ref2$format === void 0 ? 'LLS' : _ref2$format,
    _ref2$size = _ref2.size,
    tooltipSize = _ref2$size === void 0 ? 'small' : _ref2$size;
  if (tooltip) {
    return React.createElement(Tooltip, {
      size: tooltipSize,
      position: "top",
      tip: formatter(date, tooltipFormat)
    }, component);
  }
  return component;
};